import { Button, Identifier, useNotify } from "react-admin";
import { IconButton, Tooltip, Button as MuiButton, Stack } from "@mui/material";
import { Print as PrintIcon, Download as DownloadIcon } from "@mui/icons-material";
import { printDocument, downloadDocument, runDocumentAction } from "../utils/orderDocuments";

interface DownloadInvoiceProps {
  RecordId: Identifier;
  orderNumber: string;
  isList?: boolean;
  variant?: "icon" | "button" | "default";
}

export default function DownloadInvoice({
  RecordId,
  orderNumber,
  isList = false,
  variant,
}: DownloadInvoiceProps) {
  const notify = useNotify();

  // The 4x6 delivery label. Printing opens the browser's dialog; the PDF is
  // the secondary action, for emailing or filing a copy.
  const onPrint = (e: any) => {
    e.stopPropagation();
    runDocumentAction(printDocument("label", String(RecordId)), notify);
  };

  const onDownload = (e: any) => {
    e.stopPropagation();
    runDocumentAction(downloadDocument("label", String(RecordId), `${orderNumber} Label.pdf`), notify);
  };

  // Use icon button in list view
  if (isList || variant === "icon") {
    return (
      <Tooltip title="Print label">
        <IconButton
          onClick={onPrint}
          size="small"
          sx={{ color: "primary.main" }}
        >
          <PrintIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  }

  // Outlined button for quick actions bar
  if (variant === "button") {
    return (
      <Stack direction="row" spacing={0.5} alignItems="center">
        <MuiButton
          variant="outlined"
          size="small"
          startIcon={<PrintIcon />}
          onClick={onPrint}
          sx={{ borderColor: "primary.main", color: "primary.main" }}
        >
          Print Label
        </MuiButton>
        <Tooltip title="Download the label as a PDF">
          <IconButton onClick={onDownload} size="small" sx={{ color: "text.secondary" }}>
            <DownloadIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Stack>
    );
  }

  // Default react-admin button
  return (
    <Button
      sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', '&:hover': { bgcolor: 'primary.dark' } }}
      onClick={onPrint}
      label="Print Label"
    />
  );
}
